import axios from 'axios'
import qs from 'qs'
import common from '../assets/js/common.js'
export const $getJson = function (method) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: method,
      dataType: 'json',
      crossDomain: true,
      cache: false,
      headers: {
        "Authorization": 'APPCODE d745ffc46bc44a539aef35ce2eb17923'
      }
    }).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export const $postAxios = function (url, params, config) {
  // Login-Type   1：微信公众号授权；2：微信小程序授权；3：微信开放平台APP授权；4：手机号登录；5:web
  // Client-Type  1：H5（1）；2：小程序（2）；3：APP（登录方式（Login-Type：3、4））；4:web
  // 每种客户端有一种或多种登录类型，Login-Type为动态值
  var httpHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Login-Type': 5,
    'Client-Type': 4
  }
  // nGv - false 没有版本号
  let URL = config && config.isLogin ? common.Gprefix + '/' + url : common.URLProxy(url, true)
  httpHeaders.Authorization = 'Bearer ' + localStorage.getItem('token')
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: URL,
      crossDomain: true,
      cache: false,
      data: qs.stringify(params, { indices: false }),
      timeout: 6000,
      emulateJSON: true,
      headers: httpHeaders
    }).then(res => {
      resolve(res.data)
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js